import { observer } from "mobx-react-lite";

import { useRubricatorTableState } from "./table.state";
import { RubricatorTableView } from "./table.view";

export const RubricatorTable = observer(() => {
  const state = useRubricatorTableState();
  return <RubricatorTableView state={state} />;
});
